import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ChangePasswordModal } from "./ChangePasswordModal";
import { useAuth } from "@/app/auth";
import { ButtonRing } from "@/components/brand/ButtonRing";

/** Gate the app shell: wait for /me, then redirect to /login if unauthenticated. */
export function RequireAuth() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grid h-dvh place-items-center bg-paper">
        <ButtonRing size={40} tone="brand" holes={4} progress={0.7} spinning />
      </div>
    );
  }
  if (!user) {
    // Kèm cả query: bộ lọc và trang hiện tại nằm ở đó, nên bỏ nó đi là đưa
    // người dùng về đúng màn hình nhưng mất hết những gì họ vừa lọc.
    return (
      <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
    );
  }
  if (user.mustChangePassword) return <ChangePasswordModal required onClose={() => { void logout(); }} />;
  return <Outlet />;
}
